import {
  backofficeBaseDomains,
  buildBackofficeUrl,
  getSubdomainFromHostname,
} from '@backoffice-frontend/authentication'
import {
  ENV,
  isAdminPanel,
  isLocalhost,
  isPrDeployment,
} from '@backoffice-frontend/environment'
import { useExpectedSubdomain } from './ExpectedSubdomain'

export type SubdomainCheck =
  | { status: 'checking' }
  | { status: 'match' }
  | { status: 'mismatch'; expectedUrl: string }
  | { status: 'indeterminate' }

const skipCheck = isLocalhost || isPrDeployment || isAdminPanel

export const useSubdomainCheck = (): SubdomainCheck => {
  const expectedSubdomainResult = useExpectedSubdomain()
  const currentSubdomain = getSubdomainFromHostname(window.location.hostname)
  const baseDomain = backofficeBaseDomains[ENV]

  // A hostname without a subdomain, an environment without a known base
  // domain, and not having an expected subdomain (no logged in user yet) gives
  // nothing to compare against.
  if (
    skipCheck ||
    !currentSubdomain ||
    !baseDomain ||
    !expectedSubdomainResult
  ) {
    return { status: 'match' }
  }

  switch (expectedSubdomainResult.status) {
    case 'resolving':
      return { status: 'checking' }
    case 'resolved': {
      const expectedSubdomain = expectedSubdomainResult.subdomain
      return expectedSubdomain === currentSubdomain
        ? { status: 'match' }
        : {
            status: 'mismatch',
            expectedUrl: buildBackofficeUrl(
              expectedSubdomain,
              baseDomain,
              window.location,
            ),
          }
    }
    case 'unresolvable':
      return { status: 'indeterminate' }
  }
}
